const kpiNumbers = document.querySelectorAll<HTMLElement>(".kpi-number");

const animateValue = (el: HTMLElement, start: number, end: number, duration: number) => {
    let startTimestamp: number | null = null;
    const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);

        // Calculate the current value
        const currentValue = progress * (end - start) + start;

        // Format based on whether the target has decimals
        const formattedValue =
            end % 1 !== 0
                ? currentValue.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                : Math.floor(currentValue).toLocaleString("de-DE");

        el.textContent = formattedValue;

        if (progress < 1) {
            window.requestAnimationFrame(step);
        } else {
            // Ensure exact final value and formatting
            el.textContent = end.toLocaleString("de-DE");
        }
    };
    window.requestAnimationFrame(step);
};

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target as HTMLElement;
                const targetStr = el.dataset.target || "0";

                // Clean the string: remove dots (thousands) and replace comma with dot (decimal)
                const cleanedTarget = targetStr.replace(/\./g, "").replace(/,/g, ".");
                const target = parseFloat(cleanedTarget);

                if (!isNaN(target)) {
                    animateValue(el, 0, target, 1500);
                }
                observer.unobserve(el);
            }
        });
    },
    { threshold: 0.1 },
);

kpiNumbers.forEach((el) => {
    // Store the target value from data-target or initial text content
    if (!el.dataset.target) {
        el.dataset.target = el.textContent?.trim() || "0";
    }
    // Set to 0 initially for the scroll-up effect
    el.textContent = "0";
    // Add ARIA attribute to hide the rapid DOM updates from screen readers
    el.setAttribute("aria-hidden", "true");
    observer.observe(el);
});
